import { Entity, FieldType, makeClone } from 'gossamer-unified';
import { Transaction } from 'gossamer-model';
import { UserView } from './UserView';

export interface EventBulkUploadViewRow {
  user_id: string;
  trans_id: string;
  back_end_save_at: string;
  orig_event_count: number;
  curr_event_count: number;
}

const clone = makeClone();

export const EventBulkUploadView: Entity<EventBulkUploadViewRow> = {
  id: 'EventBulkUploadView',
  title: 'Event',
  service: 'main',
  rowLabel: (row: EventBulkUploadViewRow) => row.trans_id,
  primaryKeyFields: ['trans_id'],
  source: {
    tableName: 'public.event_bulk_upload_view',
  },
  security: Transaction.security,
  defaultSort: [['back_end_save_at', 'DESC']],
  fields: {
    user_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'User',
      refEntity: UserView,
      listColumn: true,
    },
    trans_id: clone(Transaction.fields.trans_id),
    back_end_save_at: clone(Transaction.fields.back_end_save_at),
    orig_event_count: {
      seq: 910,
      type: FieldType.Integer,
      label: 'Original Event Count',
      listColumn: true,
    },
    curr_event_count: {
      seq: 920,
      type: FieldType.Integer,
      label: 'Current Event Count',
      listColumn: true,
    },
  },
};
